import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";

export const FAQService = {
  fetchFaqs,
};

function fetchFaqs(projectId) {
  const token = JSON.parse(localStorage.getItem("token"));
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  };
  if (token)
    requestOptions.headers['Authorization'] = `Bearer ${token}`;


  return fetch(`${API_ROOT_URL}/projects/faqs/?q=${projectId}`, requestOptions).then(response => handleResponse(response,true))
  .then(data => {
    return data;
  });
}


// WEBPACK FOOTER //
// ./src/services/faqs.service.js